const InputForm = ({ title, rows, required }) => {
  return (
    <div className="mt-8">
      <p className="mb-4 font-pop text-xl font-semibold text-darkGreen">
        {title}
        {required && <span className="text-redBorder">*</span>}
      </p>
      {rows ? (
        <textarea
          placeholder="Enter here"
          className="h-[140px] max-h-[200px] min-h-[48px] w-full border border-lightGray px-6 py-[22px] font-pop text-xl text-black text-opacity-50 focus:outline-none"
          rows={rows}
        ></textarea>
      ) : (
        <input
          type="text"
          className="w-full border border-lightGray px-6 py-[22px] font-pop text-xl text-black text-opacity-50 focus:outline-none"
          placeholder="Enter here"
        />
      )}
    </div>
  );
};

export default InputForm;
